export interface IBug {
  id: string;
  title: string;
  body: string;
}

export const defaultBug: IBug = {
  id: '',
  title: '',
  body: '',
};
